import localCurrencies from 'config/constants/localCurrenciesExRates.json'

/**
 * Get the local currency exchange rate based on USD
 * @param localCurrency local currency
 * @returns local currency exchange rate based on USD
 */
export const getLocalCurrencyExRate = (
  localCurrency: string,
): number => {
  return localCurrencies[localCurrency?.toUpperCase()] ?? 1
}

export default null
